import type { OffersT } from './offersI18n';
import type { VariantPreviewState } from './useOfferVariantPreview';
import VariantPriceTable from './VariantPriceTable';

/** Decision "4 preview" — the per-variant price tables for every selected service, in selection order. */
export default function OfferVariantPrices({ state, t }: { state: VariantPreviewState; t: OffersT }) {
  return (
    <section className="vpt-panel" aria-labelledby="vpt-title" aria-busy={state.loading}>
      <h3 id="vpt-title" className="vpt-panel__title">{t('offers.variants.title')}</h3>
      <p className="offer-field-hint">{t('offers.variants.intro')}</p>
      {!state.ready && <p className="offer-muted">{t('offers.variants.needRule')}</p>}
      {state.ready && state.error && <div className="error-message" role="alert">{t('offers.variants.failed')}</div>}
      {state.ready && state.loading && !state.items && <p className="offer-muted" role="status">{t('offers.variants.loading')}</p>}
      {state.ready && state.items?.map((item) => <VariantPriceTable key={item.offeringId} item={item} t={t} />)}
    </section>
  );
}
